export default "__VITE_ASSET__D8G92y$m__"